import { throttle, put } from "redux-saga/effects";

import {
  SYSTEM_DICTATION_SET_LOADING_PROGRESS,
  SYSTEM_DICTATION_THROTTLED_LOADING_PROGRESS,
} from "../actions/constants";

function* saga(action: any): any {
  yield put({
    type: SYSTEM_DICTATION_SET_LOADING_PROGRESS,
    payload: action.payload,
  });
}

export function* sysSaga() {
  yield throttle(5000, SYSTEM_DICTATION_THROTTLED_LOADING_PROGRESS, saga);
}
